import { Navigate, Outlet, useLocation } from 'react-router-dom';

const RequireAuth = () => {
  const token = localStorage.getItem('accessToken');
  const location = useLocation();

  if (!token) {
    return <Navigate to="/giris" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
